/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
  alpha,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    authDialogContent: {
      display: 'flex',
      // A column so the pending prompt notice can sit above the card. With one
      // child this lays out exactly as the row it replaces.
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      // The card carries its own padding; this only keeps it clear of the
      // dialog's close button.
      padding: theme.spacing(0, 1, 2),
    },
    /**
     * Deliberately quiet: it is a receipt for something that already worked,
     * not a warning, and it sits directly above the provider buttons it must
     * not compete with. Kept narrower than the dialog so it reads as belonging
     * to the card rather than as a banner across the top of it.
     */
    promptSavedNotice: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      maxWidth: theme.spacing(45),
      padding: theme.spacing(1, 2),
      marginBottom: theme.spacing(1),
      borderRadius: theme.spacing(0.75),
      backgroundColor: alpha(theme.palette.success.main, 0.1),
      color: theme.palette.success.dark,
    },
    promptSavedIcon: {
      fontSize: theme.spacing(2),
      color: theme.palette.success.main,
      // The message wraps on a narrow screen; the tick must not squash with it.
      flexShrink: 0,
    },
  })
);
